module.exports = __webpack_public_path__ + "static/media/view talent category.449ad263.svg";